// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"61b8dc9c","308":"8a2a33ca"}[chunkId] + ".chunk.js";
};